export const FORWARDING_STEP_GUIDES = {
  client_title: {
    stage: "Титул 1",
    title: "Заполняет клиент",
    actor: "Клиент",
    actorTitle: "Кто заполняет",
    summary: "Клиент оформляет поручение экспедитору на организацию перевозки.",
    payload: "Участники, груз, маршрут, договор экспедиции и условия выполнения поручения.",
    next: "После заполнения клиент подписывает и отправляет титул.",
    note: "Это XML 1110486, без подписи он ещё не отправлен экспедитору.",
    tone: "shipper",
  },
  client_signed: {
    stage: "Титул 1",
    title: "Подписывает клиент",
    actor: "Клиент",
    actorTitle: "Кто подписывает",
    summary: "Клиент подписывает и отправляет поручение экспедитору.",
    payload: "Электронная подпись клиента к титулу 1110486.",
    next: "После отправки поручения экспедитор может заполнить свой титул.",
    tone: "shipper",
  },
  expeditor_title: {
    stage: "Титул 2",
    title: "Заполняет экспедитор",
    actor: "Экспедитор",
    actorTitle: "Кто заполняет",
    summary: "Экспедитор принимает поручение и фиксирует условия оказания услуг.",
    payload: "Результат согласования поручения, реестр и сведения об услуге экспедитора.",
    next: "После заполнения экспедитор утверждает или отклоняет поручение.",
    note: "Это XML 1110487, подпись экспедитора выполняется отдельным действием.",
    tone: "carrier",
  },
  expeditor_signed: {
    stage: "Титул 2",
    title: "Подписывает экспедитор",
    actor: "Экспедитор",
    actorTitle: "Кто подписывает",
    summary: "Экспедитор утверждает или отклоняет поручение.",
    payload: "Электронная подпись экспедитора к действию утверждения или отказа.",
    next: "Далее может оформляться экспедиторская расписка, если экспедитор принимает груз.",
    tone: "carrier",
  },
  receipt_created: {
    stage: "Экспедиторская расписка",
    title: "Заполняет экспедитор",
    actor: "Экспедитор",
    actorTitle: "Кто заполняет",
    summary: "Экспедитор оформляет расписку о получении груза.",
    payload: "Факт получения груза, участники, место приёма, груз и условия приёма.",
    next: "После создания расписку нужно подписать в Saby.",
    tone: "carrier",
  },
  receipt_signed: {
    stage: "Экспедиторская расписка",
    title: "Подписывает экспедитор",
    actor: "Экспедитор",
    actorTitle: "Кто подписывает",
    summary: "Подписанная расписка подтверждает, что экспедитор принял груз.",
    payload: "Юридически значимое подтверждение получения груза экспедитором.",
    next: "После подписи документ доступен для просмотра и скачивания.",
    tone: "neutral",
  },
};

export const FORWARDING_FALLBACK_GUIDE = {
  stage: "Этап экспедиторского документа",
  actor: "Участник ЭДО по текущему шагу",
  summary: "Этап документооборота экспедиторского документа.",
  payload: "Сведения текущего этапа.",
  next: "Следующий участник получает документ после завершения текущего шага.",
};
